module.exports = "/images/logo-everbridge.svg?26b447eb9264241b9705f9e6749d1f38";